import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation
} from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/Assets/css/globle.css";
import "./Containers/Front/showcase_2.o/Assets/global.css";
import "./App.css";
import "../src/Assets/css/custome.css";
import "../src/Assets/css/color.css";
import "../src/Assets/css/Education/style.css";
import "../src/Assets/css/productlist.css";
import "../src/Assets/css/productDetails.css";
import "../src/Assets/css/cart.css";
import "../src/Assets/css/ringsettings.css";
import "../src/Assets/css/mjstatic.css";
import "react-phone-input-2/lib/style.css";

import Home from "./Containers/Front/showcase_2.o/Home";
import React, { useEffect } from "react";
import { Suspense } from "react";
import { Skeleton } from "@mui/material";
import Login from "./Components/Login";
import { useSelector } from "react-redux";
import { isDesktop } from "react-device-detect";
import MainRequest from "./Components/mainRequest";
import MegaMenu from "./Containers/Front/showcase_2.o/Header/MegaMenu";
import { ToastContainer } from "react-toastify";

import CookiesComponent1 from "./Containers/CookiesComponent1";

import LocaleWrapper from "./i18nWrapper/LocaleWrapper";
import { routeConfig } from "./i18nWrapper/Routes";
import Footer from "./Containers/Footer/footer";
const App = () => {
  const history = useHistory();
  const login = useSelector((state) => state.persistedReducer.home.logindrawer);
  const user = useSelector((state) => state.persistedReducer.home.userData);
  const DefaultLangRedirect = () => {
    const location = useLocation();

    if (!location.pathname.startsWith("/en/") && !location.pathname.startsWith("/es/")) {
      return <Redirect to={`/en${location.pathname}`} />;
    }else if(location.pathname.startsWith("/en/")){
        return <Redirect to={`/en${location.pathname}`} />;
    }
    else if(location.pathname.startsWith("/es/")){
        return <Redirect to={`/es${location.pathname}`} />;
    }

    return null;
  };


  return (
    <>
      {/* <Redirection/> */}
      <BrowserRouter>
        <MainRequest />
        <MegaMenu />

        <div className="mainPage">
          <LocaleWrapper>
            {/* <DefaultLangRedirect /> */}
            <Switch>
              <Route
                exact
                path="/qr"
                render={(props) => (
                  <Redirect to={{ pathname: "/bespoke", search: props.location.search, hash: props.location.hash }} />
                )}
              />
              <Route
                exact
                path="/es/joyería-fina"
                render={(props) => (
                  <Redirect to={{ pathname: "/es/joyeria-fina", search: props.location.search, hash: props.location.hash }} />
                )}
              />
              <Route
                exact
                path="/es/joyería-fina/:subcategory"
                render={(props) => (
                  <Redirect to={{ pathname: `/es/joyeria-fina/${props.match.params.subcategory}`, search: props.location.search, hash: props.location.hash }} />
                )}
              />
              {routeConfig.map((route, index) => (
                <Route
                  key={index}
                  exact
                  path={[
                    route.en,
                    `/en${route.en}`,
                    `/es${route.es}`,
                    ...(route.es !== route.en ? [`/es${route.en}`] : [])
                  ]}
                >
                { (props)=> (<Suspense fallback={<Skelton />}>
                    <route.component {...props}/>
                  </Suspense>
                )}
                </Route>
              ))}
            </Switch>
          </LocaleWrapper>

          <ToastContainer />
        </div>
        <Suspense
          fallback={
            <>
              <Skelton />
            </>
          }
        >
          <Footer />
          {login && !isDesktop ? <Login /> : ""}
        </Suspense>
        <CookiesComponent1 />
      </BrowserRouter>

    </>
  );
};

// skelton component
const Skelton = () => {
  return (
    <>
      <div className="sk" style={{ margin: "15px 0px" }}>
        <Skeleton variant="text" animation="wave" />
      </div>
    </>
  );
};
// const Skeltonheader = () => {
//   return (
//     <>
//       <div className="skh" style={{ margin: "0px 0px 10px 0px" }}>
//         <Skeleton variant="text" animation="wave" height={75} />
//       </div>
//     </>
//   );
// };
export default App;
